import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { latLng, tileLayer, geoJSON, GeoJSON } from 'leaflet'
import { LeafletModule } from '@bluehalo/ngx-leaflet'
import { ProductsService } from '../../../services/products.service'
import { NgIf } from '@angular/common'

@Component({
  selector: 'app-heat-map',
  templateUrl: './heat-map.component.html',
  styleUrls: ['./heat-map.component.scss'],
  standalone: true,
  imports: [LeafletModule, NgIf],
})
export class HeatMapComponent implements OnInit {
  @Input() isVisible: boolean = false
  @Input() erpSource: string = ""

  @Output() departmentClicked = new EventEmitter<string>()

  layers: GeoJSON[] = []
  options = {
    layers: [
      tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap',
      }),
    ],
    zoom: 5,
    center: latLng(46.5, 2.5),
  }

  constructor(
    private http: HttpClient,
    private productsService: ProductsService
  ) {}

  ngOnInit(): void {
    this.productsService
      .getProductToPlanify({ erpSource: this.erpSource })
      .subscribe((affairs: any[]) => {
        const counts = this.countByDepartment(affairs)
        const max = Math.max(...Object.values(counts), 1)

        this.http.get('france.json').subscribe((geo: any) => {
          this.layers = [
            geoJSON(geo, {
              style: (feature) => {
                const code = feature?.properties.code
                const count = counts[code] || 0
                return {
                  color: '#000',
                  fillColor: this.getColor(count, max),
                  fillOpacity: 0.6,
                  weight: 1,
                }
              },
              onEachFeature: (feature, layer) => {
                const code = feature.properties.code
                const nom = feature.properties.nom
                const count = counts[code] || 0

                layer.bindTooltip(
                  `${nom} (${count} affaire${count > 1 ? 's' : ''})`,
                  {
                    sticky: true,
                    direction: 'top',
                  }
                )

                layer.on('click', () => {
                  this.departmentClicked.emit(code)
                })
              },
            }),
          ]
        })
      })
  }

  private countByDepartment(affairs: any[]): Record<string, number> {
    const countMap: Record<string, number> = {}
    for (const item of affairs) {
      const dep = item.affair?.workSiteDepartment
      if (dep) {
        countMap[dep] = (countMap[dep] || 0) + 1
      }
    }
    return countMap
  }

  private getColor(value: number, max: number): string {
    if (value === 0) return '#cccccc' // gris

    const ratio = value / max
    const r = Math.floor(255 * ratio)
    const g = Math.floor(255 * (1 - ratio))
    return `rgb(${r},${g},0)` // vert → rouge
  }
}
